import type { K2ApiTyped } from './types';

import './setup';
import { k2ApiRoot } from './root';

export const k2 = k2ApiRoot as K2ApiTyped;
